<template>
  <div class="vx-col w-full mb-base m-auto">
    <vx-card title="Manage Organisations">
      <div class="text-right add-country" v-if="!userAddEdit">
        <vs-button
          class="mt-4 m-auto"
          color="#0057FF"
          @click.prevent="userAddEdit = true"
        >Add Organisation</vs-button>
      </div>
      <div class="w-full" v-if="userAddEdit" autocomplete="off">
        <div class="vx-row mb-2">
          <h3 class="ml-5">{{ userIndex ? 'Edit' : 'Add' }} Organisations</h3>
        </div>
        <!-- <form autocomplete="off" > -->
        <div class="vx-row mb-2">
          <div class="vx-col md:w-1/3 form-group w-full">
            <vs-input
              type="text"
              class="w-full"
              label="Organisation Name"
              v-validate="'required|max:50'"
              name="name"
              v-model="name"
              autocomplete="off"
            />
            <span class="text-danger text-sm">{{ errors.first('name') }}</span>
          </div>
          <div class="vx-col md:w-1/3 form-group w-full">
            <vs-input
              type="text"
              class="w-full"
              label="Organisation URL"
              v-validate="{url: {require_protocol: false },required:true}"
              name="url"
              v-model="url"
              autocomplete="off"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('url')"
            >Please enter valid organisation URL</span>
          </div>
          <div class="vx-col md:w-1/3 form-group w-full">
            <vs-input
              type="text"
              class="w-full"
              label="Industry"
              v-validate="'required|alpha_spaces|max:50'"
              name="industry"
              v-model="industry"
              autocomplete="off"
            />
            <span class="text-danger text-sm">{{ errors.first('industry') }}</span>
          </div>
          <div class="vx-col md:w-1/3 form-group w-full">
            <vs-input
              class="w-full"
              label="Contact Person First Name"
              v-validate="'required|alpha_spaces|max:25'"
              name="first_name"
              v-model="firstName"
              type="text"
              autocomplete="off"
            />
            <span class="text-danger text-sm">{{ errors.first('first_name') }}</span>
          </div>
          <div class="vx-col md:w-1/3 form-group w-full">
            <vs-input
              class="w-full"
              label="Contact Person Last Name"
              v-validate="'required|alpha_spaces|max:25'"
              name="last_name"
              v-model="lastName"
              autocomplete="off"
              type="text"
            />
            <span class="text-danger text-sm">{{ errors.first('last_name') }}</span>
          </div>
          <div class="vx-col md:w-1/3 form-group w-full">
            <vs-input
              class="w-full"
              label="Email"
              v-validate="'required|email'"
              name="email"
              v-model="email"
              autocomplete="off"
              :disabled="userIndex"
              type="email"
            />
            <span class="text-danger text-sm">{{ errors.first('email') }}</span>
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col md:w-1/3 form-group w-full">
            <vs-input
              class="w-full"
              label="Phone"
              v-validate="'required|numeric|min:10|max:10'"
              name="phone"
              v-model="phone"
              autocomplete="off"
              type="number"
              @keydown="filterKey"
            />
            <span class="text-danger text-sm">{{ errors.first('phone') }}</span>
          </div>
          <div class="vx-col md:w-1/3 form-group w-full">
            <vs-input
              class="w-full"
              label="Designation"
              v-validate="'required|alpha_spaces|max:25'"
              name="designation"
              v-model="designation"
              autocomplete="off"
            />
            <span class="text-danger text-sm">{{ errors.first('designation') }}</span>
          </div>
          <!-- <div class="vx-col md:w-1/3 form-group w-full">
              <vs-input
                class="w-full"
                label="Contact Person Name"
                v-validate="'required|alpha_spaces'"
                name="contact_person_name"
                v-model="contact_person_name"
                autocomplete="off"
              />
              <span class="text-danger text-sm">{{ errors.first('contact_person_name') }}</span>
          </div>-->
          <div class="vx-col md:w-1/3 form-group w-full">
            <vs-input
              class="w-full"
              label="Password"
              v-validate="!userIndex ? 'required|verify_password|min:8|max:20' : ''"
              name="password"
              v-model="password"
              autocomplete="off"
              type="password"
              :disabled="userIndex"
              ref="passwordRef"
            />
            <span class="text-danger text-sm">{{ errors.first('password') }}</span>
          </div>
          <div class="vx-col md:w-1/4 form-group w-full" v-if="!userIndex">
            <vs-input
              class="w-full"
              label="Confirm Password"
              type="password"
              v-validate="'required|confirmed:passwordRef'"
              name="password_confirmation"
              v-model="confirm_password"
            />
            <span class="text-danger text-sm">{{ errors.first('password_confirmation') }}</span>
          </div>
          <div class="vx-col md:w-1/4 form-group w-full">
            <vs-select
              autocomplete
              class="w-full"
              v-validate="'required'"
              label="Timezone"
              name="org_timezone"
              v-model="org_timezone"
            >
              <vs-select-item
                :key="index"
                :value="item.timezone"
                :text="item.display +' '+item.name"
                v-for="(item,index) in allTimezone"
              />
            </vs-select>
            <span class="text-danger text-sm">{{ errors.first('org_timezone') }}</span>
          </div>
          <div class="vx-col md:w-1/4 form-group w-full">
            <vs-input
              class="w-full"
              label="No of Employees"
              v-validate="'required|numeric|max:5'"
              name="no_of_employees"
              v-model="no_of_employees"
              autocomplete="off"
            />
            <span class="text-danger text-sm">{{ errors.first('no_of_employees') }}</span>
          </div>
          <div class="vx-col md:w-1/4 form-group w-full">
            <vs-select
              autocomplete
              class="w-full"
              v-validate="'required'"
              label="Country"
              name="country"
              v-model="country"
            >
              <vs-select-item
                :key="index"
                :value="item.name"
                :text="item.name"
                v-for="(item,index) in countriesOptions"
              />
            </vs-select>
            <span class="text-danger text-sm">{{ errors.first('country') }}</span>
          </div>
          <div class="vx-col md:w-1/4 form-group w-full">
            <label>Organisation Logo</label>
            <div class="mt-5" v-if="!logo">
              <vue-image-upload
                field="img"
                @crop-success="cropSuccess"
                v-model="show_image_popup"
                v-validate="'required'"
                name="image"
                :width="100"
                :height="100"
                lang-type="en"
                img-format="png"
                :no-rotate="false"
                :no-circle="true"
                :no-square="false"
              ></vue-image-upload>
              <vs-button
                color="primary"
                @click.prevent="pickFile()"
                id="upload-profile-button"
              >Upload Logo</vs-button>
              <span class="text-danger text-sm">{{ errors.first('image') }}</span>
            </div>
            <div class v-else>
              <div class="img-upload" v-if="logo">
                <img :src="logo" class="mr-1" style="width: 200px; max-height: 60px; float:left;" />
                <vs-button
                  color="primary"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-x"
                  @click.prevent="removeLogo()"
                ></vs-button>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="vx-row mb-2">
            
            <div class="vx-col md:w-1/4 form-group w-full">
              <vs-input
                class="w-full"
                label="No Of Department"
                v-validate="'numeric|max:2'"
                name="no_of_department"
                v-model="no_of_department"
                autocomplete="off"
              />
              <span class="text-danger text-sm">{{ errors.first('no_of_department') }}</span>
            </div>
            <div class="vx-col md:w-1/4 form-group w-full">
              <vs-input
                class="w-full"
                label="No Of Locations"
                v-validate="'numeric|max:2'"
                name="no_of_locations"
                v-model="no_of_locations"
                autocomplete="off"
              />
              <span class="text-danger text-sm">{{ errors.first('no_of_locations') }}</span>
            </div>
            <div class="vx-col md:w-1/4 form-group w-full">
              <vs-input
                class="w-full"
                label="No Of Vehicles"
                v-validate="'numeric|max:5'"
                name="no_of_vehicles"
                v-model="no_of_vehicles"
                autocomplete="off"
              />
              <span class="text-danger text-sm">{{ errors.first('no_of_vehicles') }}</span>
            </div>
        </div>-->
        <!-- <div class="vx-row mb-2">
          
            <div class="vx-col md:w-1/3 form-group w-full">
              <vs-select
                autocomplete
                class="w-full"
                v-validate="'required'"
                label="User Role"
                name="role"
                v-model="roleIndex"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item,index) in role_list"
                />
              </vs-select>
              <span class="text-danger text-sm">{{ errors.first('role') }}</span>
            </div>
        </div>-->
        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <vs-button
              class="mt-1 m-auto"
              color="#0057FF"
              @click="userIndex ? updateUser() :addUpdateOrganization()"
              :disabled="button_loading"
              id="org-addupdate"
            >{{ userIndex ? 'Save' : 'Add' }}</vs-button>
            <vs-button
              class="mt-1 ml-4 m-auto"
              color="warning"
              @click.prevent="cancelAddEdit()"
            >Cancel</vs-button>
          </div>
        </div>
        <!-- </form> -->
      </div>
      <div class="mt-5 mb-5">
        <vs-table :data="organisations" pagination max-items="15">
          Organisation name, contact person name, email, total users
          <template slot="thead">
            <vs-th>Name</vs-th>
            <vs-th>Contact Person</vs-th>
            <vs-th>Email</vs-th>
            <vs-th>Locations</vs-th>
            <vs-th>Department</vs-th>
            <vs-th>Employees</vs-th>
            <vs-th>Plan</vs-th>
            <!-- <vs-th sort-key="userType">Vehicles</vs-th> -->
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{ tr.name | capitalize }}</vs-td>
              <vs-td>{{ tr.contact_person ? tr.contact_person.firstname : "-" }} {{ tr.contact_person ? tr.contact_person.lastname : "-" }}</vs-td>
              <vs-td>{{ tr.contact_person ? tr.contact_person.email : "-" }}</vs-td>
              <vs-td>{{ tr.no_of_locations}}</vs-td>
              <vs-td>{{ tr.no_of_department }}</vs-td>
              <vs-td>{{ tr.no_of_employees }}</vs-td>
              <vs-td>{{ tr.payment_plan.plan_name }}</vs-td>
              <!-- <vs-td>{{ data[indextr].no_of_vehicles}}</vs-td> -->
              <vs-td>
                <vs-button
                  color="warning"
                  type="filled"
                  class="mr-2 mb-2 float-left"
                  icon-pack="feather"
                  icon="icon-edit-2"
                  size="small"
                  title="Edit Organisation"
                  @click.stop="editOrganization(tr.id)"
                ></vs-button>
                <pre></pre>
                <vs-button
                  color="danger"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  size="small"
                  title="Delete Organisation"
                  @click.stop="confirmDelete(data[indextr].id)"
                ></vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import timeZone from "@/mixins/timezone.js";
import VueImageUpload from "vue-image-crop-upload";

Validator.extend("verify_password", {
  //getMessage: field => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (E.g. , . _ & ? etc)`,
  validate: value => {
    var strongRegex = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
    );
    return strongRegex.test(value);
  }
});

//Validator.updateDictionary(dictionary);

const dict = {
  custom: {
    industry: {
      required: "Please enter industry",
      alpha_spaces: "Only alphabetic characters and space allowed",
      max: "Industry name should not be greater than 50 characters"
    },
    name: {
      required: "Please enter name",
      alpha_spaces: "Only alphabetic characters and space allowed",
      max: "Organisation name should not be greater than 50 characters"
    },
    url: {
      required: "Please enter organisation URL",
      url: "dfdfdfdf"
    },
    contact_person_name: {
      required: "Please enter contact person name",
      alpha_spaces: "Only alphabetic characters and space allowed"
    },
    first_name: {
      required: "Please enter first name",
      alpha_spaces: "Only alphabetic characters and space allowed",
      max: "First name should not be greater than 25 characters"
    },
    last_name: {
      required: "Please enter last name",
      alpha_spaces: "Only alphabetic characters and space allowed",
      max: "Last name should not be greater than 25 characters"
    },
    email: {
      required: "Please enter email",
      email: "Please enter valid email"
    },
    phone: {
      required: "Please enter phone number",
      numeric: "Please enter valid number",
      min: "Phone number must be at least 10 digits",
      max: "Phone number may not be greater than 10 digits"
    },
    password: {
      required: "Please enter password",
      min: "Password should be minimum 6 characters",
      verify_password:
        "Password should be minimum 8 characters : 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (E.g. , . _ & ? etc)"
    },
    password_confirmation: {
      required: "Please enter confirm password",
      confirmed: "Password and confirm password should be same"
    },
    role: {
      required: "Please select user role"
    },
    url: {
      required: "Please enter URL"
    },
    designation: {
      required: "Please enter user designation",
      alpha_spaces: "Only alphabetic characters and space allowed",
      max: "Designation not be greater than 25 characters"
    },
    no_of_employees: {
      required: "Please enter no of employees",
      numeric: "Please enter valid number",
      max: "Employees may not be greater than 5 digits"
    },
    no_of_department: {
      required: "Please enter no of department",
      numeric: "Please enter valid number",
      max: "Number of department may not be greater than 2 digits"
    },
    no_of_locations: {
      required: "Please enter no of location",
      numeric: "Please enter valid number",
      max: "Number of location may not be greater than 2 digits"
    },
    no_of_vehicles: {
      required: "Please enter no of vehicles",
      numeric: "Please enter valid number",
      max: "Vehicles may not be greater than 5 digits"
    },
    org_timezone: {
      required: "Please select timezone"
    },
    country:{
      required: "Please select country"
    }
  }
};
// register custom messages
Validator.localize("en", dict);

export default {
  components: {
    "vue-image-upload": VueImageUpload
  },
  data() {
    return {
      country:null,
      industry: null,
      organisations: [],
      deleteIndex: 0,
      userAddEdit: false,
      url: null,
      name: null,
      designation: null,
      contact_person_name: null,
      firstName: null,
      lastName: null,
      email: null,
      phone: null,
      password: null,
      confirm_password: null,
      userIndex: null,
      roleIndex: null,
      no_of_employees: null,
      no_of_department: null,
      no_of_locations: null,
      no_of_vehicles: null,
      role_list: [
        {
          text: "Super Admin",
          value: "sa"
        },
        {
          text: "Admin",
          value: "ad"
        }
      ],
      org_timezone: null,
      allTimezone: timeZone.data,
      logo: "",
      show_image_popup: false,
      logo_update: false,
      editLogo: null
    };
  },
  created() {
    if (this.$store.state.uInfo.role !== "SA") {
      history.back();
    }
    //  VeeValidate.Validator.extend('verify_password', {
    //  //getMessage: field => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (E.g. , . _ & ? etc)`,
    //  validate: value => {
    //      var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    //      return strongRegex.test(value);
    //  }
    // });
  },
  // watch: {
  //   org_timezone(nv){
  //     if (nv) {
  //       alert(nv);
  //     }
  //   }
  // },
  mounted() {
    // setTimeout(() => {
    //   this.allTimezone = timeZone.data;
    // }, 500);

    this.getusers();
  },
  computed: {
    email_validate() {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(this.email);
    }
  },
  methods: {
    pickFile() {
      this.show_image_popup = !this.show_image_popup;
    },
    removeLogo() {
      this.logo = "";
    },
    cropSuccess(imgDataUrl, field) {
      this.logo = imgDataUrl;
      // if(this.$route.params.id) {
      //     this.imageUpdate = true
      // }
    },
    getusers() {
      this.$vs.loading({ color: "primary" });

      let url = "organization/getAll";
      this.axios
        .get(url)
        .then(response => {
          this.$vs.loading.close();
          let data = response.data.data;
          this.organisations = data;
        })
        .catch(e => {
          this.showError(e);
        });
    },
    confirmDelete(index) {
      this.userAddEdit = false;
      this.deleteIndex = index;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete this Organization?",
        acceptText: "Delete",
        accept: this.deleteOrganization
      });
    },
    deleteOrganization() {
      let input = {
        data: {
          id: this.deleteIndex
        }
      };
      this.$vs.loading({ color: "primary" });
      this.axios
        .delete("organization/delete", input)
        .then(response => {
          this.$vs.loading.close();
          let text = "Organization deleted successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.deleteIndex = 0;
          this.getusers();
        })
        .catch(e => {
          this.deleteIndex = 0;
          this.showError(e);
        });
    },
    editOrganization(id) {
      let url = "organization/getOne?id=" + id;
      this.axios
        .get(url)
        .then(response => {
          let org = response.data.data;
          this.userAddEdit = true;
          this.industry = org.industry;
          this.firstName = org.contact_person.firstname;
          this.lastName = org.contact_person.lastname;
          this.email = org.contact_person.email;
          this.phone = org.contact_person.phone;
          this.password = "###########";
          this.url = org.url;
          this.name = org.name;
          this.designation = org.contact_person.designation;
          this.no_of_employees = org.no_of_employees;
          this.no_of_department = org.no_of_department;
          this.no_of_locations = org.no_of_locations;
          this.no_of_vehicles = org.no_of_vehicles;
          this.userIndex = org.id;
          this.org_timezone = org.time_zone;
          this.logo = org.logo;
          this.editLogo = org.logo;
          this.country = org.country;
          this.logo_update = true;

          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
        })
        .catch(e => {
          this.showError(e);
        });
    },
    addUpdateOrganization() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.userIndex != null) {
            this.updateUser();
          } else {
            this.addUser();
          }
        }
      });
    },
    addUser() {
      this.button_loader(true, "#org-addupdate");
      let input = {
        industry: this.industry,
        firstname: this.firstName,
        lastname: this.lastName,
        email: this.email,
        phone: this.phone,
        password: this.password,
        url: this.url,
        name: this.name,
        logo: this.logo,
        designation: this.designation,
        no_of_employees: this.no_of_employees,
        no_of_department: this.no_of_department,
        no_of_locations: this.no_of_locations,
        no_of_vehicles: this.no_of_vehicles,
        time_zone: this.org_timezone,
        country :this.country
      };
      this.axios
        .post("organization/create", input)
        .then(response => {
          this.button_loader(false, "#org-addupdate");
          let text = "Organisation created successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.industry = null;
          this.country = null;
          this.userAddEdit = false;
          this.userIndex = null;
          this.firstName = null;
          this.lastName = null;
          this.email = null;
          this.phone = null;
          this.password = null;
          this.url = null;
          this.logo = null;
          this.name = null;
          this.designation = null;
          this.no_of_employees = null;
          this.no_of_department = null;
          this.no_of_locations = null;
          this.no_of_vehicles = null;
          this.org_timezone = null;
          this.getusers();
        })
        .catch(e => {
          this.showError(e, "#org-addupdate");
        });
    },
    updateUser() {
      this.button_loader(true, "#org-addupdate");

      let input = {
        id: this.userIndex,
        industry: this.industry,
        firstname: this.firstName,
        lastname: this.lastName,
        email: this.email,
        phone: this.phone,
        url: this.url,
        name: this.name,
        logo: this.logo,
        logo_update: this.logo_update,
        designation: this.designation,
        no_of_employees: this.no_of_employees,
        no_of_department: this.no_of_department,
        no_of_locations: this.no_of_locations,
        no_of_vehicles: this.no_of_vehicles,
        //time_zone: 'Pacific/Auckland'
        time_zone: this.org_timezone,
        country :this.country
      };
      // console.log('update input',input);
      this.axios
        .put("organization/edit", input)
        .then(response => {
          this.button_loader(false, "#org-addupdate");
          let text = "Organisation updated successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.userAddEdit = false;
          this.industry = null;
          this.country = null;
          this.userIndex = null;
          this.firstName = null;
          this.lastName = null;
          this.email = null;
          this.phone = null;
          this.password = null;
          this.url = null;
          this.name = null;
          this.logo = null;
          this.designation = null;
          this.no_of_employees = null;
          this.no_of_department = null;
          this.no_of_locations = null;
          this.no_of_vehicles = null;
          this.org_timezone = null;
          this.logo_update = false;
          this.logo = null;
          this.editLogo = null;
          this.getusers();
        })
        .catch(e => {
          this.showError(e, "#org-addupdate");
        });
    },
    cancelAddEdit() {
      this.userAddEdit = false;
      this.industry = null;
      this.country = null;
      this.userIndex = null;
      this.firstName = null;
      this.lastName = null;
      this.email = null;
      this.phone = null;
      this.password = null;
      this.url = null;
      this.name = null;
      this.designation = null;
      this.no_of_employees = null;
      this.no_of_department = null;
      this.no_of_locations = null;
      this.no_of_vehicles = null;
      this.org_timezone = null;
      this.logo_update = false;
      this.logo = null;
      this.editLogo = null;
    }
  }
};
</script>
<style>
.cus {
  width: 20px;
}

.cus-long {
  width: 140px;
}
.vs-table--tbody-table .tr-table td {
  padding: 10px 6px !important;
}
</style>

		